
/**
 * @file 任务状态
 * @author sunyingying01
 */

import React from 'react';

import {LoadingOutlined} from '@ant-design/icons';
import {Spin} from 'antd';
import NotStartedSvg from '@assets/icons/notStarted.svg';
import InprogressSvg from '@assets/icons/inprogress.svg';
import SuccessSvg from '@assets/icons/success.svg';
import PauseSvg from '@assets/icons/pause.svg';
import StopSvg from '@assets/icons/stop.svg';

const customIndicator = <LoadingOutlined style={{fontSize: 16, color: '#b3b3b3'}} spin />;

export const IconMap: Record<string, React.ReactNode> = {
    'ALL': null,
    'DRAFT': <NotStartedSvg />,
    'RUNNING': <InprogressSvg />,
    'COMPLETED': <SuccessSvg />,
    'PAUSED': <PauseSvg />,
    'CANCELLED': <StopSvg />,
    'TERMINATED': <StopSvg />,
    'CREATED': <InprogressSvg />,
    'FAILED': <StopSvg />,
    'COPYING': <Spin size="small" indicator={customIndicator} />
};
